import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "rules",
    defaultRoutePath: "/partnershipDeals/rule",
    menuItemScope: "administration",
    menuItemName: "rules",

    routes: [
        {
            path: "/partnershipDeals/rule",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Wizards.Create,
        },
    ],

}

export default Module;
